import React from 'react'
import { toAbsoluteUrl } from '../../_metronic/_helpers'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../_metronic/_partials/controls'


export default function Wordpress() {
    return (
        <Card>
            <CardHeader title={<span style={{ marginRight: '5px' }}>
                <img src={toAbsoluteUrl("/media/platforms/wordpress.png")} alt="" title="Wordpress Portal" height="32" width="32" style={{ marginRight: '5px' }}></img>Wordpress - Products Sync
            </span>}>
                <CardHeaderToolbar>
                </CardHeaderToolbar>
            </CardHeader>{" "}
            <CardBody>
            <a
                    type='button'
                    className='btn btn-outline-primary my-3'
                    // href='https://wp.ccdemostore.com/dashboard/api_bkp/product_multi_import.php'
                    style={{cursor:'not-allowed'}}
                // onClick={}
                >
                    <i class="fa fa-angle-right" aria-hidden="true"></i> ProductSync Step1
                </a><br />
                <a
                    type='button'
                    className='btn btn-outline-primary'
                    // href="https://wp.ccdemostore.com/dashboard/api_bkp/importProduct.php"
                    style={{cursor:'not-allowed'}}
                // onClick={}
                >
                    <i class="fa fa-angle-right" aria-hidden="true"></i> ProductSync Step2
                </a>
            </CardBody>
        </Card>
    )
}
